import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=27e8150d&scoped=true&"
import script from "./svg-icon.vue?vue&type=script&lang=ts&"
export * from "./svg-icon.vue?vue&type=script&lang=ts&"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=27e8150d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8150d",
  null
  
)

export default component.exports